import { makeEnvironmentProviders } from '@angular/core';
import { COMMO_SHARED_ENVIRONMENT_CONFIG } from './commo-shared-environment.config';
import { CommoSharedEnvironmentConfig } from './models';

export const provideCommoSharedEnvironment = (
  config: CommoSharedEnvironmentConfig,
) =>
  makeEnvironmentProviders([
    {
      provide: COMMO_SHARED_ENVIRONMENT_CONFIG,
      useValue: config,
    },
  ]);
